export default "__VITE_ASSET__w6xqm7EG__"